import cn from 'classnames';
import {
  FormEvent, memo, useEffect, useState,
} from 'react';

import CustomModal from '../CustomModal';
import CheckCircleFilledIcon from '../SVGIcons/CheckCircleFilledIcon';
import IAmEmployee from '../SVGIcons/IAmEmployee';
import IAmOutsider from '../SVGIcons/IAmOutsider';
import classes from './recommend-role-modal.module.scss';
import { RoleVariant } from './types';

interface IRecommendRoleModalProps {
  closeModal: () => void;
  onSelect: (value: RoleVariant) => void;
  isOpen: boolean;
}

function RecommendRoleModal({
  closeModal,
  onSelect,
  isOpen,
}: IRecommendRoleModalProps) {
  const [role, setRole] = useState<RoleVariant | null>(null);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    window._mtm?.push({ event: 'recommendFriend' });
    if (role) {
      onSelect(role);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setRole(null);
    }
  }, [isOpen]);

  return (
    <CustomModal.Root
      isOpen={isOpen}
      onClose={closeModal}
      Paper="form"
      paperClassName={classes['recommend-role-form__paper']}
      paperProps={{
        onSubmit: handleSubmit,
      }}
      scrollMode="modal"
    >
      <CustomModal.Header className={classes['recommend-role-form__header']}>
        <CustomModal.HeaderText>Порекомендовать друга</CustomModal.HeaderText>
        <div className={classes['recommend-role-form__subheading']}>
          Ты уже работаешь в Купере?
        </div>
      </CustomModal.Header>
      <CustomModal.Body>
        <div className={classes['recommend-role-form__selector']}>
          <button
            type="button"
            onClick={() => setRole('EMPLOYEE')}
            className={cn(classes.card, {
              [classes['card--selected']]: role === 'EMPLOYEE',
            })}
          >
            <CheckCircleFilledIcon className={classes.card__check} />
            <div className={classes['card__icon-wrapper']}>
              <IAmEmployee className={classes.card__icon} />
            </div>
            <div className={classes['card__title-wrapper']}>
              <span className={classes.card__title}>Я сотрудник</span>
            </div>
          </button>
          <button
            type="button"
            onClick={() => setRole('OUTSIDER')}
            className={cn(classes.card, {
              [classes['card--selected']]: role === 'OUTSIDER',
            })}
          >
            <CheckCircleFilledIcon className={classes.card__check} />
            <div className={classes['card__icon-wrapper']}>
              <IAmOutsider className={classes.card__icon} />
            </div>
            <div className={classes['card__title-wrapper']}>
              <span className={classes.card__title}>
                Я не работаю
                <br />
                в Купере
              </span>
            </div>
          </button>
        </div>
      </CustomModal.Body>
      <CustomModal.Footer className={classes['recommend-role-form__footer']}>
        <CustomModal.Button
          type="submit"
          disabled={role === null}
          className={classes['recommend-role-form__submit-button']}
          contentClassName={
            classes['recommend-role-form__submit-button-content']
          }
        >
          Порекомендовать друга
        </CustomModal.Button>
      </CustomModal.Footer>
    </CustomModal.Root>
  );
}

export default memo(RecommendRoleModal);
